import { Checkbox, Icon } from '~/components/atomic';
import * as S from './SelectAiCard.styled';

interface SelectAiCardProps {
  name: string;
  description: string;
  like: number;
  isSelected: boolean;
  imageUrl: string;
  onClick: () => void;
  createUsername: string;
  isMaxSelected?: boolean;
}

export default function SelectAiCard({
  name,
  description,
  like,
  isSelected,
  imageUrl,
  onClick,
  createUsername,
  isMaxSelected,
}: SelectAiCardProps) {
  return (
    <S.CharacterCard>
      <S.CharacterDetail>
        <h3 className='t'>{name}</h3>
        <p className='desc'>{description}</p>
        <div className='sub'>
          <div className='like'>
            <Icon iconName='Favorite' size={18} />
            <span>{like}</span>
          </div>

          <S.CreateUserName>@ {createUsername}</S.CreateUserName>
        </div>
      </S.CharacterDetail>
      <S.ImageWrapper>
        <img src={imageUrl} alt='thumbnail' />

        <S.CheckboxWrapper>
          <Checkbox
            checked={isSelected}
            onChange={onClick}
            colorType='blue'
            disabled={isMaxSelected && !isSelected ? true : false}
          />
        </S.CheckboxWrapper>
      </S.ImageWrapper>
    </S.CharacterCard>
  );
}
